"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStore = void 0;
/**
 * In-Memory storage for tokens.
 */
var MemoryStore = /** @class */ (function () {
    function MemoryStore() {
        this.data = new Map();
    }
    Object.defineProperty(MemoryStore.prototype, "length", {
        get: function () {
            return this.data.size;
        },
        enumerable: false,
        configurable: true
    });
    MemoryStore.prototype.clear = function () {
        this.data.clear();
    };
    MemoryStore.prototype.getItem = function (key) {
        return this.data.get(key) || null;
    };
    MemoryStore.prototype.key = function (index) {
        return Array.from(this.data.keys())[index] || null;
    };
    MemoryStore.prototype.removeItem = function (key) {
        this.data.delete(key);
    };
    MemoryStore.prototype.setItem = function (key, value) {
        this.data.set(key, value);
    };
    return MemoryStore;
}());
exports.MemoryStore = MemoryStore;
